<div class="side-sheet keypad active">
  <div class="d-flex h-100">
    <div class="overlay" (click)="closeNumKeyPad()"></div>

    <div class="sheet-container">

      <div class="sheet-head">
        <div class="title">{{title}}</div>

        <button type="button" mat-icon-button (click)="closeNumKeyPad()">
          <img src="./assets/images/icons/close.svg" alt="">
        </button>
      </div>

      <div class="sheet-content">
        <div class="value"><div>{{value}}</div></div>
        <div class="options">
          <div matRipple
            [class.active]="valueType == 'Value' && hasPercentage"
            (click)="valueType = 'Value'">{{currency.currencyCode}}</div>
          <div matRipple
            *ngIf="hasPercentage"
            [class.active]="valueType == 'Percentage'"
            (click)="valueType = 'Percentage'; value = ''">%</div>
        </div>

        <div class="key-grid">
          <div class="nums-grid">
            <ng-container *ngFor="let item of counter(10); index as i">
              <div *ngIf="i" matRipple class="key" (click)="keyClicked(10-i)">{{10-i}}</div>
            </ng-container>
            <div matRipple class="key" (click)="keyClicked('.')">.</div>
            <div matRipple class="key zero" (click)="keyClicked('0')">0</div>
          </div>
          <div class="keys">
            <div matRipple class="key clear" (click)="clear()">C</div>
            <div matRipple class="key ok" (click)="okClicked()">OK</div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
